// Generated by purs version 0.15.15
var emptyRouteState = {
    segments: [  ],
    params: [  ],
    hash: ""
};
export {
    emptyRouteState
};
//# sourceMappingURL=index.js.map
